export default __webpack_public_path__ + "static/media/plan-dots.e65b4af0.svg";